import Button from "../Button";

export type MessageModalProps = {
  isOpen?: boolean;
  title?: string;
  isErrorAck?: boolean;
  buttons?: {
    onAction(): void;
    text: string;
    style?: React.CSSProperties | undefined;
  }[];
  boxStyle?: React.CSSProperties | undefined;

};

function MessageModal(props: MessageModalProps) {
  if (!props.isOpen) {
    return <div />;
  }

  return (
    <div
      className="flex fixed top-0 left-0 h-full w-full"
      style={{
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="flex bg-saveProgramDivBgColor"
        style={{
          flexDirection: "column",
          padding: "40px 50px",
          boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.3)",
          justifyContent: "center",
          alignItems: "left",
          maxWidth: '90%',
          ...(props.boxStyle || {}),
        }}
      >
        <span
          style={{
            fontSize: 40,
            fontWeight: 700,
            textAlign: "center",
            marginBottom: props.isErrorAck ? 0 : 30,
            whiteSpace: 'pre-wrap'
          }}
          dangerouslySetInnerHTML={{ __html: props.title?.replace(/\r\n/g, '<br/>') || '' }}
        >
        </span>
        <div style={{
          textAlign: 'center'
        }}>
          {props?.buttons?.map((item, index) => (
            <Button
              key={index}
              options={{
                text: item.text,
                class: "bg-buttonKeyboardBgColor",
                cb: item.onAction,
              }}
              style={{
                width: 150,
                margin: 10,
                boxShadow: "4px 4px 8px  rgba(0, 0, 0, 0.3)",
                ...item.style || {},
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default MessageModal;
